export default __webpack_public_path__ + "static/media/recipients.e8c84b54.svg";